// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => ("static/js/" + chunkId + "." + {"656":"c40e345a","877":"7b308a8b"}[chunkId] + ".chunk.js");